class loadingButton extends HTMLElement {
  constructor() {
    super()
    this.url = '';
    this.automaticLoading = this.getAttribute('automatic-loading')
    this.loadButton =  this.querySelector('button');
    this.productContainer =  document.querySelector('#product-grid');
    this.vanillaPagination =  document.querySelector('.pagination');
    this.moreItemsElement =  document.querySelector('.pagination__item--prev');
    this.paginationWrapper = document.querySelector('.pagination-wrapper');
    this.counter = this.querySelector('.collection-counter');
    this.currentyVisibleItemsCounter = this.counter.querySelector('.current-items-displayed')
    this.loadButton.addEventListener(
      'click',
      this.loadMore.bind(this)
    );

    // loading observer
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25
    };
    this.observer = new IntersectionObserver(this.handleIntersection, options);
  }

  connectedCallback() {
    if (this.automaticLoading === 'infinite-scroll' ) {
      this.observer.observe(this.loadButton);
    }
    if (!this.moreItemsElement) {
      this.loadButton.classList.add('hidden');
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest('loading-button').loadMore();
      }
    });
  }

  loadMore() {
    this.url = this.vanillaPagination.querySelector('.pagination__item--prev').href;
    this.loadButton.classList.add('loading');
    this.loadButton.querySelector('.loading__spinner').classList.remove('hidden');
    this.fetchItems(this.url);
  }

  fetchItems(url) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      this.renderProductGrid(html);
      this.renderNewNavigation(html);
      this.loadingButtonChecker();
    });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPage
  }
  renderNewNavigation(html) {
    this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.pagination').innerHTML;
    this.updateCounter();
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove('loading');
    this.loadButton.querySelector('.loading__spinner').classList.add('hidden');
    if (document.querySelectorAll('.pagination-wrapper a.pagination__item--prev').length === 0) {
      this.loadButton.classList.add('hidden')
      this.paginationWrapper.classList.add('hidden');
    }
  }
  updateCounter() {

    const paginationElement = document.querySelector('.pagination ul');
    if (Number(paginationElement.dataset.totalVisible) > Number(paginationElement.dataset.totalItems)) {
      this.currentyVisibleItemsCounter.textContent = paginationElement.dataset.totalItems;
    } else {
      this.currentyVisibleItemsCounter.textContent = paginationElement.dataset.totalVisible;
    }
  }
}

customElements.define('loading-button', loadingButton)